import React, { useContext, useMemo } from 'react';
import { Container } from 'reactstrap';
import { AppFooter } from '@coreui/react';
import cn from 'classnames';

import { lazyLoad } from 'utils';
import { ChangePassword, ErrorBoundary, ExternalUserBanner } from 'components';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { OnlineCheck } from 'components/Common';
import { AppToastContainer } from 'components/Toast';
import { AuthContext } from 'context/AuthContext';

const RetexAppOnboarding = lazyLoad(() => import('views/OnBoarding'));
const TrackingAppOnboarding = lazyLoad(() =>
  import('views/OnboardingTrackingApp')
);

export default function EmptyLayout() {
  const { appType } = useContext(AuthContext);

  const Component = useMemo(() => {
    if (appType.retex) return RetexAppOnboarding;
    else if (appType.shipmentTracking) return TrackingAppOnboarding;
    return () => null;
  }, [appType]);

  const containerClassName = cn('default-layout-container', {
    retexAppContainer: appType.retex,
    trackingAppContainer: appType.shipmentTracking
  });

  return (
    <div className="app EmptyLayout">
      <div className="app-body">
        <ExternalUserBanner
          hasMaxWidth
          className="EmptyLayout__externalUserBanner"
        />
        <DefaultHeader />
        <main className="main">
          <OnlineCheck />
          <ErrorBoundary>
            <Container fluid className={containerClassName}>
              <AppToastContainer />
              <Component />
            </Container>
            <ChangePassword.Modal />
          </ErrorBoundary>
          <AppFooter>
            <DefaultFooter />
          </AppFooter>
        </main>
      </div>
    </div>
  );
}
